var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDelete = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10.25,
  height: 10.25,
  viewBox: "0 0 10.25 10.25",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-4.875-4.875h20v20h-20z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#348CFD",
  strokeLinecap: "round",
  strokeWidth: 1.25
}, /*#__PURE__*/React.createElement("path", {
  d: "m.625.625 9 9M9.625.625l-9 9"
})))));
export { SvgIconDelete as ReactComponent };
export default __webpack_public_path__ + "assets/images/icon-delete.svg";